import styled from "@emotion/styled";
import { Stack } from "react-bootstrap";
import { IStyledComponentProps } from "../../../theme/theme.types";

const PageControls = styled(Stack)<IStyledComponentProps>`
  &.page-controls {
    padding: 0;
    margin: 0;

    .ms-auto {
      font-size: ${(props) => props.theme.fontSizes.small}px;
    }
  }
`;

export default { PageControls };
